import { Grid, Typography } from '@mui/material';
import React from 'react';
import { FeeTierTable } from './feeTierTable';

export function OneOffFeeFields(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>
        This fee is only ever charged once to the client.
      </Typography>
      <FeeTierTable />
    </Grid>
  );
}
